import  { createContext, useContext, useState, useEffect, useCallback } from 'react';
// import axiosconfig from '../config/axiosConfig';
import { fetchCompanyLogoUrl } from '../utils/companyLogo';

// Get API base URL from current domain
const getApiBaseUrl = () => {
  const currentUrl = window.location.hostname;
  const port = window.location.port || (window.location.protocol === 'https:' ? '443' : '80');
  const apiPort = '4000'; // API server port
  return `${window.location.protocol}//${currentUrl}:${apiPort}`;
};

const CompanyContext = createContext();

export const useCompany = () => {
  const context = useContext(CompanyContext);
  if (!context) {
    throw new Error('useCompany must be used within a CompanyProvider');
  }
  return context;
};

export const CompanyProvider = ({ children }) => {
  const [companyLogoSrc, setCompanyLogoSrc] = useState(null);

  const [companyData, setCompanyData] = useState({
    companyName: 'MessageOS', // Default fallback
    companyLogo: null,
    supportEmail: null,
    redirectUrl: null,
    customeruuid: null,
    hasRedirectUrl: false,
    isValidated: false,
    isLoading: true
  });

  const validateUrl = async () => {
    try {
      // Get the current domain dynamically
      const currentUrl = window.location.hostname;

      // COMMENTED OUT: API call to /landing/validate-url
      // const response = await axiosconfig.post('/landing/validate-url', {
      //   url: currentUrl
      //   // url:"meta.indtrack.co.in"
      //   // url:"demo.indtrack.co.in"
      // });

      // COMMENTED OUT: API response handling
      // if (response.data && response.data.success) {
      //   const { data } = response.data;
      //   console.log("data",data);
      //   console.log('Redirecting to:', data.redirectUrl);
      //   // Check if redirectUrl exists and redirect immediately
      //   if (data?.redirectUrl) {
      //     console.log('Redirecting to:', data.redirectUrl);
      //     window.location.href = data.redirectUrl;
      //     return; // Exit early to prevent further processing
      //   }

      //   // Success case - update with company data
      //   const logoUrl = data?.logo && data.logo.startsWith('http')
      //     ? data.logo
      //     : data?.logo
      //       ? `${window.location.protocol}//${window.location.host}:4000/api/uploads/${data.logo}`
      //       : null;
      //   // Check if customeruuid exists in sessionStorage (from partner application)
      //   const storedCustomerUuid = sessionStorage.getItem('customeruuid');
      //   const finalCustomerUuid = storedCustomerUuid || data?.customeruuid;

      //   setCompanyData({
      //     companyName: data?.companyName || 'MessageOS',
      //     companyLogo: logoUrl,
      //     supportEmail: data?.supportEmail,
      //     redirectUrl: data?.redirectUrl,
      //     customeruuid: finalCustomerUuid,
      //     hasRedirectUrl: !!data?.redirectUrl,
      //     isValidated: true,
      //     isLoading: false
      //   });

      //   // Store in sessionStorage if we got it from API
      //   if (finalCustomerUuid) {
      //     sessionStorage.setItem('customeruuid', finalCustomerUuid);
      //   }
      // } else {
      //   // Failed validation - keep defaults
      //   setCompanyData(prev => ({
      //     ...prev,
      //     hasRedirectUrl: false,
      //     isValidated: false,
      //     isLoading: false
      //   }));
      // }

      // Set default values when API is commented out
      setCompanyData(prev => ({
        ...prev,
        hasRedirectUrl: false,
        isValidated: true, // Set to true to avoid loading state
        isLoading: false
      }));
    } catch (error) {
      console.error('URL validation failed:', error);
      // On error, keep default values
      setCompanyData(prev => ({
        ...prev,
        hasRedirectUrl: false,
        isValidated: false,
        isLoading: false
      }));
    }
  };

  useEffect(() => {
    // COMMENTED OUT: validateUrl() API call
    // validateUrl();

    // Set default state instead
    setCompanyData(prev => ({
      ...prev,
      hasRedirectUrl: false,
      isValidated: true,
      isLoading: false
    }));
  }, []);

  /**
   * Fetches logo_url from GET /company/profile and stores it.
   * Avatar/img components handle S3 load errors via their onError fallback.
   */
  const loadCompanyLogo = useCallback(async () => {
    const url = await fetchCompanyLogoUrl();
    setCompanyLogoSrc(url);
  }, []);

  // Function to update customeruuid (for partner applications)
  const updateCustomerUuid = (newCustomerUuid) => {
    // console.log('Updating company context customeruuid to:', newCustomerUuid);
    
    // Update sessionStorage
    sessionStorage.setItem('customeruuid', newCustomerUuid);
    
    // Update context state
    setCompanyData(prev => ({
      ...prev,
      customeruuid: newCustomerUuid
    }));
  };

  const value = {
    companyData,
    validateUrl,
    updateCustomerUuid,
    isLoading: companyData.isLoading,
    companyLogoSrc,
    loadCompanyLogo,
  };

  return (
    <CompanyContext.Provider value={value}>
      {children}
    </CompanyContext.Provider>
  );
};
